import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import {FormsModule} from "@angular/forms";
import {MealKitIconButtonComponent} from "@yoni/mealcomponents-lib";
import {EnvDescriptor, EnvLoader} from "../../Environment/EnvLoader";
import {AuthService, User} from "../../Services/auth.service";
import {EnterpriseResponse} from "../../Services/gestion.service";
import { CookieService } from "ngx-cookie-service";
import { QdmService } from "app/Services/qdm.service";

// @ts-ignore
@Component({
    imports: [
        FormsModule,
        MealKitIconButtonComponent
    ],
    selector: "restaurant-login-form",
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <div
         class="w-full h-full overflow-none pb-32 md:pb-2 p-2 flex justify-center items-center bg-gris-4">
      <div class="bg-white p-4 text-black rounded border border-gris-3 fg-noir-2 flex flex-col">
        <div class="w-full flex items-center justify-center gap-2 fg-orange-1">
            <span class="material-icons">
                lock
            </span>
          <p class="font-bold">Connexion requise</p>
        </div>
        <p class="font-medium mt-4">
          L'accès à l'établissement est <b>restreint</b> et nécessite la <b>connexion</b> à <b>votre compte</b>.
        </p>

        <form action="javascript:void(0);" autocomplete="on" method="post" id="loginForm" class="flex flex-col">
          <input (keydown.enter)="this.verifyComboCredentials()" 
                [(ngModel)]="this.combo.email"
                 autocomplete="username email" class="text-sm font-medium mt-4 my-1 w-full rounded py-2 px-2 border border-gray-300 bg-white transition duration-200 ease-in-out
               hover:border-green-500 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-500"
                 name="email"
                 placeholder="Adresse e-mail" type="email">

          <div class="w-full relative">
            <input (keydown.enter)="this.verifyComboCredentials()" 
                  [(ngModel)]="this.combo.password"
                   [attr.type]="this.isPasswordShown ? 'text' : 'password'"
                   autocomplete="current-password" class="font-medium text-sm my-1 w-full rounded py-2 px-2 border border-gray-300 bg-white transition duration-200 ease-in-out
               hover:border-green-500 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-500 pr-12"
                   id="password"
                   name="password"
                   placeholder="Mot de passe">

            <span (click)="this.togglePasswordVisibility()"
                  class="select-none material-icons absolute right-2 top-1/2 -translate-y-1/2 z-10 cursor-pointer">
          {{ this.isPasswordShown ? 'visibility' : 'visibility_off' }}
        </span>
          </div>
          
          <a (click)="this.redirectToForgetPassword()"
             class="ml-auto rounded transition p-2 text-xs font-semibold fg-noir-2 w-fit hover:bg-gris-4"
             href="javascript:void(0);">Mot de passe oublié ?</a>
             
          <button type="submit" style="display:none"></button>
        </form>

        <mk-icon-button (click)="this.verifyComboCredentials()" [height]="40"
                        [icon]="this.comboErrorMessage !== '' ? 'error' : 'key'"
                        [label]="this.comboErrorMessage || 'Accéder à l\\'établissement'"
                        [type]="this.comboErrorMessage !== '' ? 'dark' : 'primary'" class="w-full mt-4"
                        useSvg="false"/>
      </div>

    </div>
  `
})
export class RestaurantLoginFormComponent implements OnInit{
  private cdr = inject(ChangeDetectorRef);
  private auth = inject(AuthService);
  private cookie = inject(CookieService);
  private qdm = inject(QdmService);


  protected comboErrorMessage: string = "";

  protected isPasswordShown: boolean = false;
  protected combo: {email: string, password: string} = {email: "", password: ""};
  private env!: EnvDescriptor;
  ngOnInit(): void {
    this.combo = {email: "", password: ""};
    this.env = EnvLoader.load();
    
    // Ajouter un écouteur d'événement sur le formulaire
    setTimeout(() => {
      const form = document.getElementById('loginForm');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.verifyComboCredentials();
        });
      }
    }, 0);
  }

  verifyComboCredentials() {
    const {email, password} = this.combo;

    if(email === "" || password === "") {
      this.error("Veuillez remplir tous les champs.");
      return;
    }

    if(!email.includes("@") || !email.includes(".")) {
      this.error("Adresse e-mail invalide.");
      return;
    }

    this.error("Connexion en cours...", -1);

    this.auth.login(email, password).then((r: ({ token: string, refresh_token: string, user: User | undefined, entData: EnterpriseResponse|null })) => {
      // Informer le navigateur que la connexion a réussi
      const form = document.getElementById('loginForm') as HTMLFormElement;
      if (form) {
        const submitEvent = new Event('submit', { cancelable: true });
        form.dispatchEvent(submitEvent);
      }

      setTimeout(() => {
        this.cookie.set("goto", this.qdm.selectedRestaurantSubject.value?.id.toString() || "", {path: "/"});
        window.location.reload();
      }, 100);

    }).catch((e: any) => {
      if(typeof e === "string") {
        this.error(e);
        return;
      }

      if(e.message === "Unauthorized"){
        this.error("Adresse e-mail ou mot de passe incorrect !");
        return;
      }

      this.error("Erreur: " + e.message);
    });
  }

  togglePasswordVisibility() {
    this.isPasswordShown = !this.isPasswordShown;
  }

  redirectToForgetPassword() {
    window.open(this.env.boGestionUrl + "/reset-password", "_blank");
  }

  private error(message: string, time: number = 2000) {
    this.comboErrorMessage = message;
    this.cdr.detectChanges();

    if(time === -1) {
      return;
    }
    setTimeout(() => {
      this.comboErrorMessage = "";
      this.cdr.detectChanges();
    }, time);
  }
}